<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>
      @if (!aiAssistant()?.assistant?.id) {
        {{ 'AI_ASSISTANT.SETTINGS.CREATE_CUSTOM_ASSISTANT_TITLE' | translate }}
      } @else {
        {{ 'AI_ASSISTANT.SETTINGS.TITLE' | translate: { assistantName: aiAssistant()?.assistant?.name } }}
      }
      @if (showBetaBadge()) {
        <glxy-badge [color]="'green'" class="beta-badge">{{ 'AI_ASSISTANT.SHARED.BETA' | translate }}</glxy-badge>
      }
    </glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <form [formGroup]="assistantForm" class="form-wrapper">
      <!-- Avatar -->
      <div class="avatar">
        @if (loading()) {
          <glxy-loading-spinner class="avatar-loading-spinner"></glxy-loading-spinner>
        } @else {
          <ai-image-upload
            (imageUrlChanged)="onImageChanged($event)"
            [imageUrl]="assistantForm.get('assistantAvatarUrl')?.value"
            [defaultSvg]="aiAssistant()?.decoration?.defaultAvatarIcon ?? defaultAvatarIcon"
          ></ai-image-upload>
        }
      </div>

      <!-- Name -->
      <glxy-form-field>
        <glxy-label>
          {{ 'AI_ASSISTANT.SETTINGS.ASSISTANT_NAME' | translate }}
          <mat-icon class="info-icon" [glxyTooltip]="'AI_ASSISTANT.SETTINGS.ASSISTANT_NAME_TOOLTIP' | translate">
            info_outline
          </mat-icon>
        </glxy-label>
        <input
          matInput
          id="assistant-name"
          formControlName="name"
          placeholder="{{ 'AI_ASSISTANT.SETTINGS.DEFAULT_ASSISTANT_NAME' | translate }}"
        />
      </glxy-form-field>
    </form>
    <ai-sticky-footer (submitClick)="submit()" (cancelClick)="back()" [disabled]="saving()"></ai-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>
